import { type Plugin, shallowRef, readonly } from 'vue'
import merge from 'lodash/merge'
import {
  type Config,
  type UpdateConfig,
  type ConfigInjectionValue,
  CONFIG_INJECTION_KEY,
  PREDEFINED_CONFIG
} from './config'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $ui: {
      updateConfig: UpdateConfig
    }
  }
}

export default {
  install: (app, options) => {
    const config = shallowRef(merge({}, PREDEFINED_CONFIG, options))

    const updateConfig: UpdateConfig = updates => {
      config.value = merge({}, config.value, updates)
    }

    app.config.globalProperties.$ui = {
      updateConfig
    }

    app.provide(CONFIG_INJECTION_KEY, {
      config: readonly(config),
      updateConfig
    } satisfies ConfigInjectionValue)
  }
} satisfies Plugin<Config>
